import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDCustomer_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDCustomer_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SelectSTDCustomer: any[];
  SelectSTDCustomer_dummy: any[];
  UploadFile: any;
  UploadFile_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  STDCustomerSave: number;
  STDCustomerSave_dummy: number;
  ReturnStringEverthing: string;
  ReturnStringEverthing_dummy: string;
  STDLogsSave: number;
  STDLogsSave_dummy: number;
  STDCustomerProductFileSave: number;
  STDCustomerProductFileSave_dummy: number;
}

export class STDCustomer_Form_ScreenBase extends React.PureComponent<
  ISTDCustomer_Form_ScreenProps,
  any
> {
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "44ef904b-b094-40ba-abd9-f95c253ba812",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 145918, PropertyName: "value", Value: "Müşteri Form" },
        { Id: 299552, PropertyName: "value", Value: "Aktiflik" },
        { Id: 404333, PropertyName: "value", Value: "Firma Adı" },
        { Id: 760471, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 21881, PropertyName: "value", Value: "Firma Logo" },
        { Id: 396079, PropertyName: "value", Value: "Firma Kodu" },
        { Id: 798365, PropertyName: "placeholder", Value: "15" },
        { Id: 612425, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdcustomer_form_760471_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      SelectSTDCustomer: [],
      UploadFile: "",
      SetValueOf: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDCustomer_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdcustomer_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDCustomer_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdcustomer_form_178727_value:
        this.state.SelectSTDCustomer?.at?.(0)?.customerStatus ?? undefined,
      stdcustomer_form_760471_value:
        this.state.SelectSTDCustomer?.at?.(0)?.name ?? undefined,
      stdcustomer_form_807040_value:
        this.state.SelectSTDCustomer?.at?.(0)?.customerLogo ?? undefined,
      stdcustomer_form_798365_value:
        this.state.SelectSTDCustomer?.at?.(0)?.customerCode ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDCustomer_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_Form/STDCustomer_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDCustomer_Form",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDCustomer_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerCreate
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerEdit
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDCustomer_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDCustomer_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_Form/STDCustomer_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDCustomer = result?.data.selectSTDCustomer;
    formVars.stdcustomer_form_178727_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerStatus
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerStatus
        : null
    );
    formVars.stdcustomer_form_760471_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );
    formVars.stdcustomer_form_807040_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );
    formVars.stdcustomer_form_798365_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDCustomer_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDCustomer_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdcustomer_form_178727_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerStatus
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerStatus
        : null
    );

    formVars.stdcustomer_form_760471_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].name
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].name
        : null
    );

    formVars.stdcustomer_form_807040_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerLogo
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerLogo
        : null
    );

    formVars.stdcustomer_form_798365_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDCustomer !== undefined
        ? stateVars.SelectSTDCustomer?.length > 0
          ? stateVars.SelectSTDCustomer[0].customerCode
          : null
        : this.state.SelectSTDCustomer?.length > 0
        ? this.state.SelectSTDCustomer[0].customerCode
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDCustomer_FormComponent_275519_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_FormComponent_763167_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFileWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stdcustomer_form_807040_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.UploadFile?.data),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDCustomer_FormComponent_612425_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdcustomer_form_798365_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdcustomer_form_798365_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdcustomer_form_760471_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdcustomer_form_760471_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].createdDate
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].createdDate
            : null
        ),
        "Date"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_798365_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CustomerStatus_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_178727_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CustomerLogo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_807040_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_760471_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      parameter1_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Müşteri bilgisi güncellendi:",
          "string"
        ),
        "string"
      ),
      parameter2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_760471_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(5, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_Form/STDCustomer_FormComponent_612425_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerSave = result?.data.stdCustomerSave;
    stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
    stateVars.STDLogsSave = result?.data.stdLogsSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDCustomer_FormComponent_612425_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdcustomer_form_798365_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdcustomer_form_798365_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdcustomer_form_760471_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdcustomer_form_760471_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedDate_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_798365_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CustomerStatus_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_178727_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      CustomerLogo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_807040_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_760471_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      FileData_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      FileName_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      parameter1_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Müşteri oluşturuldu:",
          "string"
        ),
        "string"
      ),
      parameter2_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdcustomer_form_760471_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EventId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      LogStatus_3: ReactSystemFunctions.convertToTypeByName(2, "number"),
      LogText_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDCustomer_Form/STDCustomer_FormComponent_612425_onClick_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerSave = result?.data.stdCustomerSave;
    stateVars.STDCustomerProductFileSave =
      result?.data.stdCustomerProductFileSave;
    stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
    stateVars.STDLogsSave = result?.data.stdLogsSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDCustomer_FormComponent_612425_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDCustomer !== undefined
            ? stateVars.SelectSTDCustomer?.length > 0
              ? stateVars.SelectSTDCustomer[0].id
              : null
            : this.state.SelectSTDCustomer?.length > 0
            ? this.state.SelectSTDCustomer[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDCustomer_FormComponent_612425_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDCustomer_FormComponent_612425_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDCustomer_Form"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDCustomer_FormPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDCustomer_FormPageInit();
    }
  }
}
